"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = exports.shadows = exports.radii = exports.mediaQueries = exports.lineHeights = exports.letterSpacings = exports.fontWeights = exports.fontSizes = exports.fontFamilies = exports.colors = exports.borderWidths = void 0;
exports.borderWidths = require('./tokens/borderWidths').default;
exports.colors = require('./tokens/colors').default;
exports.fontFamilies = require('./tokens/fontFamilies').default;
exports.fontSizes = require('./tokens/fontSizes').default;
exports.fontWeights = require('./tokens/fontWeights').default;
exports.letterSpacings = require('./tokens/letterSpacings').default;
exports.lineHeights = require('./tokens/lineHeights').default;
exports.mediaQueries = require('./tokens/mediaQueries').default;
exports.radii = require('./tokens/radii').default;
exports.shadows = require('./tokens/shadows').default;
exports.spacing = require('./tokens/spacing').default;
//# sourceMappingURL=tokens.js.map